import React, {FC, HTMLAttributes} from 'react';
import css from "./SubscribeAgain.module.scss";
import joobler from "../../../../assets/unsubscribe/images/joobler.svg";
import Button from "../../../../elements/Button/Button";
import {SubscriptionSettingsTranslation} from "../../interfaces/SubscriptionSettingsTranslation";
import {useNavigate} from "react-router-dom";
import {RouteNames} from "../../../../router";
import $api from "../../../../http";
import {Contact} from "../../interfaces/Contact";

interface SubscribeAgainProps extends HTMLAttributes<HTMLDivElement> {
    localization: SubscriptionSettingsTranslation,
    countryCode?: string,
    contact: Contact,
}

const SubscribeAgain: FC<SubscribeAgainProps> = ({contact, localization, countryCode}) => {
    const navigate = useNavigate();

    const handleClick = async () => {
        const result = await $api.post('/api/Subscription/UnsubscribeUpdate', {
            id: contact.id,
            name: contact.name,
            countryCode: contact.countryCode,
            language: contact.language,
            deletedOn: contact.deletedOn,
            cancelledSubscriptions: []
        })
        if (result.status === 200) {
            navigate(RouteNames.SUBSCRIPTION_SUBSCRIBED, {
                state: {
                    title: localization.YouHaveSubscribed,
                    subTitle: localization.WillKeepYouUpdated,
                    btnName: localization.GoToJooble,
                    countryCode
                }
            })
        }
    }

    return (
        <section className={css.main}>
            <img className={css.main__logo} src={joobler} alt="joobler"/>
            <h2 className={css.main__title}>{localization?.YouAreNotSubscriber}</h2>
            <div className={css.main__subTitle}>
                <p>{localization?.ThankYouForLongSubscribe}</p>
                <p>{localization?.WrongUnsubscribe}</p>
            </div>
            <Button onClick={handleClick}>{localization?.SubscribeAgain}</Button>
        </section>
    );
};

export default SubscribeAgain;